import React, { useMemo } from 'react';
import MuiButton from '@mui/material/Button';
import { CircularProgress } from './Progress';
import styledBy from './util/styledBy';
import { styled } from './styled';

export { default as Fab } from '@mui/material/Fab';

const textColor = (theme) => (props) => (
  props.variant === 'contained' ? styledBy('color', {
    success: theme.palette.common.white,
    favorite: theme.palette.getContrastText(theme.palette.favorite.main),
    convert: theme.palette.common.white,
  })(props) : undefined
);

const generateButtonWrapper = (component) => styled(component, {
  shouldForwardProp: (p) => !['fullWidth', 'startIcon', 'endIcon', 'disableElevation'].includes(p),
})(({ theme, ...props }) => ({
  position: 'relative',
  width: (props.fullWidth ? '100%' : undefined),
  display: 'block',
  '& .MuiButton-root': {
    textTransform: 'none',
    color: textColor(theme)(props),
  },
  '& .MuiCircularProgress-root': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

export const Button = React.forwardRef((props, ref) => {
  const {
    loadingSize = 24,
    loading = false,
    disabled = false,
    onClick,
    className,
    wrapperComponent = 'div',
    ...rest
  } = props;

  const Wrapper = useMemo(() => generateButtonWrapper(wrapperComponent), [wrapperComponent]);

  return (
    <Wrapper className={className} {...rest}>
      <MuiButton ref={ref} disabled={loading || disabled} onClick={onClick} {...rest} />
      {loading && <CircularProgress size={loadingSize} className='buttonProgress' />}
    </Wrapper>
  );
});
